(() => {
  const reminder = document.querySelector('[data-dd-cart-reminder]');
  if (!reminder) return;
  const key = 'dd-cart-reminder-v1';
  let completed = false;
  try { completed = sessionStorage.getItem(key) === 'done'; } catch (_) {}
  if (completed) return;
  const browsingDelay = Math.max(5, Number(reminder.dataset.delay) || 45) * 1000;
  const returningDelay = Math.max(5, Number(reminder.dataset.returningDelay) || 15) * 1000;
  const arrivalKey = 'dd-cart-reminder-arrival-v1';
  let arrivalCart;
  try { arrivalCart = sessionStorage.getItem(arrivalKey); } catch (_) {}
  let delay = arrivalCart === 'existing' ? returningDelay : browsingDelay;
  let count = 0;
  let timer;
  let scheduled = false;
  let loading = false;
  let shown = false;
  let unsubscribe;
  let aliaOpen = false;
  const aliaObservers = new Map();
  const syncAlia = () => {
    let open = false;
    for (const [root, watcher] of aliaObservers) {
      if (!root.isConnected) {
        watcher.disconnect();
        aliaObservers.delete(root);
        continue;
      }
      const style = getComputedStyle(root);
      if (!root.hidden && root.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden') open = true;
    }
    if (open === aliaOpen) return;
    aliaOpen = open;
    clearTimeout(timer);
    timer = undefined;
    shown = false;
    reminder.hidden = true;
    queue();
  };
  const watchAlia = (root) => {
    if (!root.id?.startsWith('alia-root-') || aliaObservers.has(root)) return;
    const watcher = new MutationObserver(syncAlia);
    watcher.observe(root, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
    aliaObservers.set(root, watcher);
    syncAlia();
  };
  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  };
  const blocked = () => aliaOpen || document.hidden || document.body.classList.contains('overflow-hidden') ||
    !!document.querySelector('cart-drawer.active, header details[open], details-modal details[open], dialog[open]') ||
    [...document.querySelectorAll('[aria-modal="true"], [role="dialog"]')].some(visible);
  const remember = () => { try { sessionStorage.setItem(key, 'done'); } catch (_) {} };
  const finish = () => {
    completed = true;
    clearTimeout(timer);
    reminder.hidden = true;
    remember();
    observer.disconnect();
    for (const watcher of aliaObservers.values()) watcher.disconnect();
    aliaObservers.clear();
    unsubscribe?.();
    document.removeEventListener('visibilitychange', queue);
    window.removeEventListener('pageshow', refresh);
  };
  const update = () => {
    scheduled = false;
    if (completed) return;
    if (!count || blocked()) {
      clearTimeout(timer);
      timer = undefined;
      reminder.hidden = true;
      return;
    }
    if (shown) { clearTimeout(timer); timer = undefined; reminder.hidden = false; return; }
    if (timer) return;
    timer = setTimeout(async () => {
      timer = undefined;
      await refresh(false);
      if (completed || !count || blocked()) return;
      reminder.querySelector('[data-reminder-count]').textContent =
        (count === 1 ? reminder.dataset.one : reminder.dataset.many).replace('__COUNT__', count);
      reminder.hidden = false;
      shown = true;
      remember();
    }, delay);
  };
  function queue() {
    if (scheduled || completed) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  async function refresh(reschedule = true) {
    if (loading || completed) return;
    loading = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      count = Number(cart.item_count) || 0;
      if (arrivalCart !== 'existing' && arrivalCart !== 'new') {
        arrivalCart = count > 0 ? 'existing' : 'new';
        delay = arrivalCart === 'existing' ? returningDelay : browsingDelay;
        try { sessionStorage.setItem(arrivalKey, arrivalCart); } catch (_) {}
      }
      reminder.querySelector('[data-reminder-count]').textContent =
        (count === 1 ? reminder.dataset.one : reminder.dataset.many).replace('__COUNT__', count);
    } catch (_) { count = 0; }
    finally { loading = false; }
    if (reschedule) queue();
  }
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.target !== document.body) continue;
      for (const node of record.addedNodes || []) {
        if (node.nodeType === 1) watchAlia(node);
      }
      if ([...aliaObservers.keys()].some((root) => !root.isConnected)) syncAlia();
    }
    queue();
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'aria-modal'] });
  document.querySelectorAll('[id^="alia-root-"]').forEach(watchAlia);
  reminder.querySelector('[data-reminder-close]').addEventListener('click', finish);
  reminder.querySelector('[data-reminder-open]').addEventListener('click', (event) => {
    const drawer = document.querySelector('cart-drawer');
    const opener = document.getElementById('cart-icon-bubble');
    if (window.matchMedia('(max-width: 749px)').matches && drawer && typeof drawer.open === 'function' && opener) {
      event.preventDefault();
      finish();
      drawer.open(opener);
    } else { finish(); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
  }
  document.addEventListener('visibilitychange', queue);
  window.addEventListener('pageshow', refresh);
  refresh();
})();
